<p-toast position="bottom-left">
</p-toast>

<div class="login" style="background-color: #f2f4f7;">
  @if(imagePath){
  <div class="col-left" [ngStyle]="{ 'background-image': 'url(' + imagePath + ')' }">
  </div>
  }
  @if(imagePath === undefined){
  <div class="col-left">
    <div class="swiper mySwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img src="assets/images/slide-1.jpg" />
          <div class="slider-caption">
            <p>Work Withouy Walls<br />From your contact center in the clouds.</p>
          </div>
        </div>
        <div class="swiper-slide">
          <img src="assets/images/slide-2.jpg" />
          <div class="slider-caption">
            <p>Elevate Agents to all-stars<br />Help agents save the day-every day.</p>
          </div>
        </div>
        <div class="swiper-slide">
          <img src="assets/images/slide-3.jpg" />
          <div class="slider-caption">
            <p>Agents, make yourselves at home.<br />Employee attraction and retention is more competitive than ever.</p>
          </div>
        </div>
      </div>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
  }
  <div class="col-right">
    <form name="authForm" novalidate style="height: 100%">
      <div class="login-form">
        <div class="form">
          <div class="form__inner">
            <div class="form__header">
              <div class="login-logo">
                <img src="assets/images/logo.svg">
              </div>
              <p class="small-text">
                An email has been sent to you, please copy the code and paste below:
              </p>
            </div>

            <div class="form__group">
              <label class="form__label">ENTER CONFIRMATION CODE</label>
              <div class="single-input-field-wrapper">
                <div class="form__filed">
                  <input style="    font-family: inherit;
    font-size: 14px;
    color: #292929;
    padding: 7px 5px;
    border-radius: 3px;
    background: white !important;
    border: 0;
    border-bottom: 1px solid #d0d7dd;
    width: 100%;
    max-width: 420px;" type="code" name="code" [(ngModel)]="code" [disabled]="!isEmailSent"
                    required /> 
                  @if(isError && !code){
                  <div class="validation validation--error bottom-n15">
                    {{ 'Code is required.' }}
                  </div>
                  }
                </div>
              </div>
            </div>

            @if(isEmailSent){
            <div class="form__group">
            <a class="dont-get-email hand" style="color: #F15A24;" (click)="sendCodeEmail()">Didn't get the email? Send again.</a>
        </div>
            }
            <fieldset class="form__group login--actions">
              <button class="login-btn" (click)="submitCode(code)">Confirm Account</button>
            </fieldset>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>